module.exports = __webpack_public_path__ + "static/media/icon_sneak_peek@3x.db03f0dd.png";